var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"go-top",on:{"click":_vm.goTop}})
}
var staticRenderFns = []

export { render, staticRenderFns }